/* Six Fathoms theme: side cart, cart page, quantity buttons, collection filter, age check, Garden Street pop-up. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
  };

  /* ---------- cart ---------- */
  const drawer = $('[data-cart-drawer]');
  const pageSection = $('[data-cart-page]');
  const sectionIds = () => ['cart-drawer', pageSection && pageSection.dataset.sectionId].filter(Boolean).join(',');

  function paint(sections) {
    if (!sections) return;
    const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
    if (drawer && sections['cart-drawer']) {
      const next = $('[data-drawer-content]', parse(sections['cart-drawer']));
      if (next) $('[data-drawer-content]', drawer).innerHTML = next.innerHTML;
    }
    if (pageSection && sections[pageSection.dataset.sectionId]) {
      const next = $('[data-cart-page-content]', parse(sections[pageSection.dataset.sectionId]));
      if (next) $('[data-cart-page-content]', pageSection).innerHTML = next.innerHTML;
    }
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = n; el.hidden = n === 0; });
  }
  function openDrawer() {
    if (!drawer || pageSection) return; // on the cart page itself, stay on the page
    if (!drawer.open) drawer.showModal();
  }
  async function refreshCount() {
    const cart = await fetch('/cart.js').then((r) => r.json());
    setCount(cart.item_count);
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-add-to-cart]');
    if (!form) return;
    e.preventDefault();
    const btn = $('[type="submit"]', form);
    if (btn) btn.disabled = true;
    const body = new FormData(form);
    body.append('sections', sectionIds());
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', body, headers: { Accept: 'application/json' } });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || 'Could not add to cart');
      paint(data.sections);
      await refreshCount();
      openDrawer();
    } catch (err) {
      alert(err.message);
    } finally {
      if (btn) btn.disabled = false;
    }
  });

  async function changeLine(line, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)), sections: sectionIds() }),
    });
    const cart = await res.json();
    paint(cart.sections);
    setCount(cart.item_count);
  }
  document.addEventListener('click', (e) => {
    const change = e.target.closest('[data-line-change]');
    if (change) { changeLine(change.dataset.lineChange, change.dataset.qty); return; }

    const toggle = e.target.closest('[data-cart-toggle]');
    if (toggle && drawer && !pageSection) { e.preventDefault(); openDrawer(); return; }

    if (e.target.closest('[data-drawer-close]') || e.target === drawer) { drawer.close(); return; }

    const step = e.target.closest('[data-qty-step]');
    if (step) {
      const input = $('input', step.closest('[data-qty]'));
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.dataset.qtyStep));
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-input]');
    if (input) changeLine(input.dataset.lineInput, input.value);
  });

  /* ---------- product gallery thumbnails ---------- */
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    const g = thumb.closest('[data-gallery]');
    const i = thumb.dataset.galleryThumb;
    const main = $('.gallery_main', g);
    if (main.scrollWidth > main.clientWidth + 1) { // phones: the photos are a swipe row
      main.scrollTo({ left: $(`[data-gallery-slide="${i}"]`, g).offsetLeft - main.offsetLeft, behavior: 'smooth' });
    } else {
      $$('[data-gallery-slide]', g).forEach((s) => { s.hidden = s.dataset.gallerySlide !== i; });
    }
    $$('[data-gallery-thumb]', g).forEach((t) => t.classList.toggle('is-active', t === thumb));
  });
  // phones: keep the dots in step with swiping
  $$('[data-gallery]').forEach((g) => {
    const main = $('.gallery_main', g);
    main.addEventListener('scroll', () => {
      if (main.scrollWidth <= main.clientWidth + 1) return;
      const i = String(Math.round(main.scrollLeft / main.clientWidth));
      $$('[data-gallery-thumb]', g).forEach((t) => t.classList.toggle('is-active', t.dataset.galleryThumb === i));
    }, { passive: true });
  });

  /* ---------- sliders (the Garden Street pop-up photos): swipe, dots, and a gentle auto-advance ---------- */
  $$('[data-slider]').forEach((sl) => {
    const track = $('[data-slider-track]', sl); const dots = $$('[data-slider-dot]', sl); let i = 0; let timer;
    const go = (n) => { i = (n + dots.length) % dots.length; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); mark(); };
    const mark = () => dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    const start = () => { clearInterval(timer); if (dots.length > 1) timer = setInterval(() => go(i + 1), 3500); };
    dots.forEach((d) => d.addEventListener('click', () => { go(Number(d.dataset.sliderDot)); start(); }));
    track.addEventListener('scroll', () => { const n = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); if (n !== i) { i = n; mark(); } }, { passive: true });
    track.addEventListener('pointerdown', start);
    window.addEventListener('resize', () => track.scrollTo({ left: i * track.clientWidth }));
    start();
  });

  /* ---------- collection filter chips ---------- */
  $$('[data-filter-scope]').forEach((scope) => {
    const chips = $$('[data-filter]', scope);
    chips.forEach((chip) => chip.addEventListener('click', () => {
      const f = chip.dataset.filter;
      chips.forEach((c) => { const on = c === chip; c.classList.toggle('is-active', on); c.setAttribute('aria-pressed', on); });
      $$('[data-type]', scope).forEach((card) => {
        if (f === 'all' || card.dataset.type === f) card.removeAttribute('data-filter-hidden');
        else card.setAttribute('data-filter-hidden', '');
      });
    }));
  });

  /* ---------- Garden Street pop-up ---------- */
  const popup = $('[data-gsgc]');
  const params = new URLSearchParams(location.search);
  // Arriving on the Garden Street link always queues the pop-up, even if this browser has seen it before.
  // It then shows once, after the age check, and not again while they browse.
  const gsgcTags = popup ? popup.dataset.gsgcRef.split(',').map((t) => t.trim().toLowerCase()).filter(Boolean) : [];
  const fromGsgc = [params.get('ref'), params.get('utm_source')].some((v) => v && gsgcTags.includes(v.toLowerCase()));
  if (fromGsgc) { store.set('sf_gsgc_pending', '1'); store.set('sf_gsgc_seen', '0'); store.set('sf_gsgc_member', '1'); }
  // Garden Street visitors get the member code on their cart straight away. It stays on the cart and applies
  // once what's in it qualifies, so it works however they add the bottles.
  function applyMemberCode() {
    const code = popup && popup.dataset.gsgcCode;
    if (!code) return Promise.resolve(null);
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code, sections: sectionIds() }) }).then((r) => r.json()).catch(() => null);
  }
  if (fromGsgc) { document.documentElement.classList.add('gsgc-member'); applyMemberCode().then((c) => c && paint(c.sections)); }
  // A returning member sees member prices, so put the code back on the cart if it has gone (a new cart after
  // an order, or an expired one). Otherwise the prices on the cards would not match the checkout.
  else if (store.get('sf_gsgc_member') === '1' && popup && popup.dataset.gsgcCode) {
    const code = popup.dataset.gsgcCode.toLowerCase();
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json())
      .then((c) => { if (!(c.discount_codes || []).some((d) => (d.code || '').toLowerCase() === code)) return applyMemberCode().then((x) => x && paint(x.sections)); })
      .catch(() => {});
  }
  function maybeShowPopup() {
    if (!popup || store.get('sf_gsgc_pending') !== '1' || store.get('sf_gsgc_seen') === '1') return;
    store.set('sf_gsgc_seen', '1');
    popup.showModal();
  }
  // the bar keeps the offer in view once the pop-up is closed, on every page, for club visitors
  const bar = $('[data-gsgc-bar]');
  const showBar = () => { if (bar && store.get('sf_gsgc_member') === '1' && !(popup && popup.open)) bar.hidden = false; };
  if (popup) {
    popup.addEventListener('close', showBar);
    if (bar) $('[data-gsgc-open]', bar).addEventListener('click', () => { bar.hidden = true; popup.showModal(); });
    popup.addEventListener('click', (e) => {
      const browse = e.target.closest('[data-gsgc-browse]');
      if (browse && location.pathname === new URL(browse.href).pathname) { e.preventDefault(); popup.close(); return; }
      if (e.target.closest('[data-gsgc-close]') || e.target === popup) popup.close();
      const bundle = e.target.closest('[data-gsgc-bundle]');
      if (bundle) {
        const items = bundle.dataset.gsgcBundle.split(',').map((id) => ({ id: Number(id), quantity: 1 }));
        bundle.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: sectionIds() }) })
          .then((r) => r.json()).then(async (data) => {
            const withCode = await applyMemberCode();
            popup.close(); paint((withCode && withCode.sections) || data.sections); await refreshCount(); openDrawer();
          })
          .finally(() => { bundle.disabled = false; });
        return;
      }
      const shop = e.target.closest('[data-gsgc-shop]');
      if (shop && location.pathname === new URL(shop.href).pathname) { e.preventDefault(); popup.close(); }
    });
  }

  /* ---------- age check ---------- */
  const gate = $('[data-age-gate]');
  const DAY = 864e5;
  const passed = () => Number(store.get('sf_age_until')) > Date.now();
  function pass() {
    store.set('sf_age_until', String(Date.now() + 30 * DAY));
    document.documentElement.classList.add('age-ok');
    maybeShowPopup(); showBar();
  }
  function state(s) {
    gate.dataset.state = s;
    const first = $(`[data-age-state="${s}"] input:not([readonly])`, gate);
    if (first) first.focus();
  }
  function error(form, msg) {
    const el = $('[data-age-error]', form);
    el.textContent = msg; el.hidden = !msg;
  }
  if (!gate || passed()) {
    document.documentElement.classList.add('age-ok');
    maybeShowPopup(); showBar();
  } else {
    const now = new Date();
    const thisYear = now.getFullYear();
    const show = () => setTimeout(() => state('year'), 700);
    if (document.readyState === 'complete') show(); else window.addEventListener('load', show, { once: true });

    $('[data-age-year-form]', gate).addEventListener('submit', (e) => {
      e.preventDefault();
      const y = parseInt($('[data-age-year]', gate).value, 10);
      if (!(y >= 1900 && y <= thisYear)) { error(e.target, 'Enter your year of birth as four numbers, for example 1990.'); return; }
      error(e.target, '');
      const age = thisYear - y;
      if (age > 18) pass();
      else if (age < 18) state('under');
      else { $('[data-age-yy]', gate).value = y; state('day'); }
    });
    $('[data-age-day-form]', gate).addEventListener('submit', (e) => {
      e.preventDefault();
      const d = parseInt($('[data-age-dd]', gate).value, 10);
      const m = parseInt($('[data-age-mm]', gate).value, 10);
      const y = parseInt($('[data-age-yy]', gate).value, 10);
      const birth = new Date(y, m - 1, d);
      if (!(m >= 1 && m <= 12 && d >= 1 && birth.getMonth() === m - 1)) { error(e.target, 'Enter the day and month as numbers, for example 07 and 03.'); return; }
      error(e.target, '');
      const eighteenth = new Date(y + 18, m - 1, d);
      if (now >= eighteenth) pass(); else state('under');
    });
  }
})();
